<template>
  <FormCard
    v-model="user"
    @formSubmit="$emit('formSubmit', $event)">
    <CardForm
      :resource="user"
      resource-name="user"
      :section-title="$t('user.changePass')"
      :subtitle="$t('user.strongPassText')">
      <TextInput
        v-model="user.current_password"
        name="user[current_password]"
        type="password"
        :custom-label="$t('user.currentPass')"
        required />
      <TextInput
        ref="newPassword"
        v-model="user.password"
        name="user[password]"
        type="password"
        :custom-label="$t('user.newPass')"
        required
        class="mb-0"
        :html-options="{ minLength: 8 }"
        @keyup="handleNewPassword" />
      <div class="password-strength" id="passwordStrength">
        <div class="password-strength-indicator">
          <div v-for="index in 4" :key="index" class="password-strength-indicator-bar" ref="strengthBars" />
        </div>
        <div class="password-strength-label">
          <p class="password-strength-label-feedback" :style="{ color: feedback.color }">
            {{ errors[0] }}
          </p>
          <p class="password-strength-label-rating" :style="{ color: feedback.color }">
            {{ feedback.rating }}
          </p>
        </div>
      </div>
      <TextInput
        ref="confirmPassword"
        v-model="user.password_confirmation"
        name="user[password_confirmation]"
        type="password"
        :custom-label="$t('user.confirmPass')"
        required
        :html-options="{ minLength: 8 }"
        @keyup="checkOriginalPassword" />
    </CardForm>
  </FormCard>
</template>

<script>
import FormCard from "../../../shared/components/UI/FormCard.vue";
import CardForm from "../../../shared/components/UI/CardForm.vue";
import TextInput from "../../../shared/components/UI/TextInput.vue";

export default {
  name: 'UserPasswordForm',

  components: {
    FormCard,
    CardForm,
    TextInput
  },

  props: ['user'],

  data: function () {
    return {
      errors: [],
      passwordStrength: 0,
      feedback: {
        rating: "Very Weak",
        color: ""
      }
    }
  },

  methods: {
    handleNewPassword (e) {
      this.passwordStrength = 0;
      this.errors = [];

      this.checkPasswordStrength(e.target);
      this.handlePasswordStrength(e.target);

      if (this.errors.length === 0) {
        this.checkConfirmationPassword(e.target);
      }
    },

    checkPasswordStrength (element) {
      let password = element.value;

      if (password.match(/[a-z]+/)) {
        this.passwordStrength+=1;
      } else {
        this.errors.push(this.$t('user.passwordValidation.letters'));
      }
      if (password.match(/[A-Z]+/)) {
        this.passwordStrength+=1;
      } else {
        this.errors.push(this.$t('user.passwordValidation.letters'));
      }
      if (password.match(/[0-9]+/)) {
        this.passwordStrength+=1;
      } else {
        this.errors.push(this.$t('user.passwordValidation.number'));
      }
      if (password.match(/[#?!@$%^&*-]+/)) {
        this.passwordStrength+=1;
      } else {
        this.errors.push(this.$t('user.passwordValidation.special'));
      }
      if (password.length >= 8) {
        this.passwordStrength+=1;
      } else {
        this.errors.push(this.$t('user.passwordValidation.length'));
      }
    },

    handlePasswordStrength (element) {
      this.$refs.strengthBars.forEach((bar) => bar.removeAttribute("style"));

      switch(this.passwordStrength) {
      case 0:
        this.feedback.rating = this.$t('user.passwordValidation.veryWeak');
        this.feedback.color = "";
        this.$refs.strengthBars.forEach((bar) => bar.removeAttribute("style"));
        element.setCustomValidity(this.errors[0]);
        break;
      case 1:
        this.feedback.rating = this.$t('user.passwordValidation.veryWeak');
        this.feedback.color = "var(--danger)";
        this.$refs.strengthBars[0].style.setProperty("background-color", "var(--danger)");
        element.setCustomValidity(this.errors[0]);
        break;
      case 2:
        this.feedback.rating = this.$t('user.passwordValidation.weak');
        this.feedback.color = "var(--danger)";
        this.$refs.strengthBars.slice(0, 2).forEach((bar) =>
          bar.style.setProperty("background-color", "var(--danger)")
        );
        element.setCustomValidity(this.errors[0]);
        break;
      case 3:
        this.feedback.rating = this.$t('user.passwordValidation.moderate');
        this.feedback.color = "var(--warning)";
        this.$refs.strengthBars.slice(0, 3).forEach((bar) =>
          bar.style.setProperty("background-color", "var(--warning)")
        );
        element.setCustomValidity(this.errors[0]);
        break;
      case 4:
        this.feedback.rating = this.$t('user.passwordValidation.moderate');
        this.feedback.color = "var(--warning)";
        this.$refs.strengthBars.slice(0, 3).forEach((bar) =>
          bar.style.setProperty("background-color", "var(--warning)")
        );
        element.setCustomValidity(this.errors[0]);
        break;
      case 5:
        this.feedback.rating = this.$t('user.passwordValidation.great');
        this.feedback.color = "var(--success)";
        this.$refs.strengthBars.forEach((bar) =>
          bar.style.setProperty("background-color", "var(--success)")
        );
        element.setCustomValidity("");
        break;
      }
    },

    checkConfirmationPassword (element) {
      let confirmationInput = this.$refs['confirmPassword'].$el.querySelector('input');

      if (confirmationInput.value && confirmationInput.value !== element.value) {
        confirmationInput.setCustomValidity('');
       element.setCustomValidity(this.$t('user.passwordValidation.passwordConfirmationMismatch'));
      } else {
       element.setCustomValidity('');
      }
    },

    checkOriginalPassword (e) {
      let originalInput = this.$refs['newPassword'].$el.querySelector('input');

      if (originalInput.value && originalInput.value !== e.target.value) {
        e.target.setCustomValidity(this.$t('user.passwordValidation.passwordConfirmationMismatch'));

        if (this.errors.length === 0) {
          originalInput.setCustomValidity('');
        }
      } else {
        e.target.setCustomValidity('');
      }
    }
  }
};
</script>
